
import { IPlot } from "@interfaces/IPlot";
import { RouteStatus } from "@tms/_enums/RouteStatus";
import { TrackingMode } from "@tms/_enums/TrackingMode";
import { UserAccessType } from "@tms/_enums/UserAccessType";
import { IPlannedRouteNote } from "./IPlannedRouteNote";
import { IPlannedRouteVisit } from "./IPlannedRouteVisit";
import { ITmsRouteRules } from "./ITmsRouteRules";

export enum VisitType {
    Planned,
    Unplanned
}

export interface IPlannedRoute {
    Id: number;
    AccountId: number;
    RouteTemplateId?: number;
    Name: string;
    VehicleId?: number;
    DriverId?: number;
    CreationDateTime?: Date;
    LastUpdateDateTime?: Date;
    CreatedBy?: UserAccessType;
    ExternalReference: string;
    ActualStartTime?: Date;
    StartPlotId?: number;
    StartPlot: IPlot;
    ActualEndTime?: Date;
    EndPlotId?: number;
    EndPlot: IPlot;
    PlannedStartTime: Date;
    PlannedEndTime?: Date;
    Status: RouteStatus;
    TrackingMode: TrackingMode;
    PlannedVisits: IPlannedRouteVisit[];
    PlannedRouteNotes: IPlannedRouteNote[];
    TmsRouteRulesJson: string;
    TmsRouteRules: ITmsRouteRules;
}

export interface IImportedPlannedRoute {
    Value?: IPlannedRoute;
    Error?: string;
    IsError: boolean;
}
